import React from 'react';
import {Table, TableBody, TableCell, TableHead, TableRow} from '@material-ui/core';
import PropTypes from 'prop-types';
import {AvailStringField, StringComparingComponent} from '../../../../value-comparing/helper-components';
import {ValueComparer} from '../../../../value-comparing/value-comparer';

const MetadataSection = ({metadataValues, oldValue}) => {
  const valueComparer = new ValueComparer();

  const renderRequiredComponent = (valueToRender, oldValueToCompare, currentKey) => {
    if (currentKey.toLowerCase() === 'releasehistory') {
      return <ReleaseHistorySection key={currentKey} oldValue={oldValueToCompare} values={valueToRender} />;
    }

    if (currentKey.toLowerCase() === 'altidentifier') {
      return <AltIdentifierSection key={currentKey} oldValue={oldValueToCompare} values={valueToRender} />;
    }

    if (currentKey.toLowerCase() === 'ratings') {
      return <RatingsSection key={currentKey} oldValue={oldValueToCompare} values={valueToRender} />;
    }

    if (valueComparer.isValue(valueToRender)) {
      return (
        <AvailStringField
          assignedKey={currentKey}
          key={currentKey}
          oldValue={oldValueToCompare}
          value={valueToRender}
        />
      );
    }
  };

  return (
    <div style={{marginLeft: '15px', paddingLeft: '15px', borderLeft: '1px solid black'}}>
      <h4>Metadata</h4>
      {Object.keys(metadataValues).map(key => renderRequiredComponent(metadataValues[key], oldValue?.[key], key))}
    </div>
  );
};

MetadataSection.propTypes = {
  metadataValues: PropTypes.object,
  oldValue: PropTypes.object,
};

export default MetadataSection;

const ReleaseHistorySection = ({values, oldValue}) => {
  const headValues = Object.keys(values[0]);
  return (
    <div>
      <h4>Release History</h4>
      <Table>
        <TableHead>
          <TableRow>
            {headValues.map(key => (
              <TableCell key={key}>{key}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {values.map((release, rowIndex) => (
            <TableRow key={rowIndex}>
              {headValues.map(key => (
                <TableCell key={key}>
                  <StringComparingComponent current={release?.[key]?.value} previous={oldValue?.[key]?.value} />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

ReleaseHistorySection.propTypes = {
  oldValue: PropTypes.array,
  values: PropTypes.array,
};

const AltIdentifierSection = ({values, oldValue}) => {
  const headValues = Object.keys(values[0]);
  return (
    <div>
      <h4>Alt Identifier</h4>
      <div>
        <Table align="left">
          <colgroup>
            {headValues.map((_, index) => (
              <col key={index} style={{width: index === headValues.length - 1 ? '100%' : '10%'}} />
            ))}
          </colgroup>
          <TableHead>
            <TableRow>
              {headValues.map(key => (
                <TableCell key={key}>{key}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {values.map((identifier, index) => (
              <TableRow key={index}>
                {headValues.map(key => {
                  const oldIdentifier = oldValue && oldValue[index];

                  return (
                    <TableCell key={key}>
                      <StringComparingComponent current={identifier?.[key]} previous={oldIdentifier?.[key]} />
                    </TableCell>
                  );
                })}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};

AltIdentifierSection.propTypes = {
  oldValue: PropTypes.array,
  values: PropTypes.array,
};

const RatingsSection = ({values, oldValue = {}}) => {
  const {rating: ratingsCollection} = values;
  const {rating: oldRatings = []} = oldValue;
  const headValues = Object.keys(ratingsCollection[0]);

  return (
    <>
      <h4>Ratings</h4>
      <Table>
        <TableHead>
          <TableRow>
            {headValues.map(key => (
              <TableCell key={key}>{key}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {ratingsCollection.map((rating, index) => {
            const oldRatingValue = oldValue && oldValue[index];

            return (
              <TableRow key={index}>
                {headValues.map(key => {
                  const oldRatingVersion = oldRatings[index];
                  if (key.toLowerCase() === 'reason') {
                    return (
                      <TableCell key={key}>
                        {rating.reason.map((reason, reasonIndex) => (
                          <p key={reasonIndex}>
                            <StringComparingComponent current={reason} previous={oldRatingValue?.reason} />
                          </p>
                        ))}
                      </TableCell>
                    );
                  }

                  if (key.toLowerCase() === 'region') {
                    return (
                      <TableCell key={key}>
                        {rating.region.country && (
                          <AvailStringField
                            assignedKey="Country"
                            oldValue={oldRatingVersion && oldRatingVersion?.region?.country}
                            value={rating.region.country}
                          />
                        )}
                        {rating.region.countryRegion && (
                          <AvailStringField
                            assignedKey="Region"
                            oldValue={oldRatingVersion && oldRatingVersion?.region?.countryRegion}
                            value={rating.region.countryRegio}
                          />
                        )}
                      </TableCell>
                    );
                  }

                  return (
                    <TableCell key={key}>
                      <StringComparingComponent current={rating[key]} previous={oldRatingVersion && rating?.[key]} />
                    </TableCell>
                  );
                })}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </>
  );
};

RatingsSection.propTypes = {
  oldValue: PropTypes.object,
  values: PropTypes.object,
};
